import React  from 'react';
import {  Link } from 'react-router-dom'; 

import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import Slider from '../common/Slider'; 
import AboutHome from '../components/AboutHome'; 
import WhyChooseHome from '../components/WhyChooseHome'; 
import ProductsHome from '../components/ProductsHome'; 
import FeaturedHome from '../components/FeaturedHome'; 
import ProjectsHome from '../components/ProjectsHome'; 
import ClientsHome from '../components/ClientsHome'; 
import {api_base_url, base_url} from '../common/Constants';
import { Helmet } from "react-helmet";

 
class Home extends React.Component{

    constructor(){
        super();
        this.state = { 
            content:[],
            loading:true,
            banners:[],
            products:[],
            divisions:[],
            projects:[],
            services:[],
            clients:[],
            metas:[]
        }
    }
     
    componentDidMount()
    {
       
        if(this.state.loading === true)
       {
        
        this.setState({banners:JSON.parse(localStorage.getItem("home_banners"))});
        this.setState({content:JSON.parse(localStorage.getItem("content"))});  
        this.setState({divisions:JSON.parse(localStorage.getItem("divisions"))}); 
        this.setState({services:JSON.parse(localStorage.getItem("services"))}); 
        this.setState({projects:JSON.parse(localStorage.getItem("projects"))}); 
        this.setState({metas:JSON.parse(localStorage.getItem("metas"))}); 
        this.setState({loading:false});
        this.setState({clients:JSON.parse(localStorage.getItem("clients"))}); 
        
       }
      
    }
   

    render()
    {
        if (this.state.loading) {
            return <div>Loading...</div>;
          }
        return (
<div>
          
      <Header/> 
      <Helmet>
      <title>{this.state.metas[0].title}</title>  
        <meta name="description" content={this.state.metas[0].meta_description} />
        <meta name="keywords" content={this.state.metas[0].meta_title} />
        <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
        <link rel="canonical" href={base_url} />
      </Helmet>

      <Slider banners={this.state.banners}/>
      <AboutHome content={this.state.content}/>
      <ProjectsHome  content={this.state.content} divisions={this.state.divisions}/>

      <FeaturedHome  content={this.state.content}  services={this.state.services} /> 
      <WhyChooseHome content={this.state.content}/>
      <ClientsHome content={this.state.content}  clients={this.state.clients}/>
      {/******** <ProductsHome  content={this.state.content} projects={this.state.projects}/> *******/}
      
    
      
      <Footer/>
        
      
       </div>
      
       
        )
    }

}
export default Home;